// PREFIX matches the backend WebSocket event types (EHR/SYNC_*) emitted by
// the NestJS gateway in medwork-api/src/leads/gateway/leads.gateway.ts.
const PREFIX = 'EHR';

export const LIST_EHR_SYNC_ISSUES = `${PREFIX}/LIST`;
export const SYNC_ALL_LEADS = `${PREFIX}/SYNCS_LIST`;
export const SYNC_LEAD_BY_ID = `${PREFIX}/SYNC_LIST`;
export const LIST_EHR_SYNC_INFO = `${PREFIX}/LIST_SYNC_INFO`;

export const MODAL_OPEN_SET_NOT_FOUND = `${PREFIX}/MODAL_OPEN_SET_NOT_FOUND`;
export const MODAL_SET_CLOSED = `${PREFIX}/MODAL_SET_CLOSED`;
export const MODAL_SELECT_ITEM = `${PREFIX}/MODAL_SELECT_ITEM`;
export const MODAL_INPUT_EHR_PATIENT_ID = `${PREFIX}/MODAL_INPUT_EHR_PATIENT_ID`;

export const MODAL_TRIGGER_NOT_FOUND = `${PREFIX}/MODAL_TRIGGER_NOT_FOUND`;
export const MODAL_CLEAN = `${PREFIX}/MODAL_CLEAN`;

// These four action types must EXACTLY match what the backend emits via
// WebSocket. See LeadsGateway.ehrSync* methods in the API.
export const SYNC_LAST_UPDATED = `${PREFIX}/SYNC_LAST_UPDATED`;
export const SYNC_MANUAL_ALL = `${PREFIX}/SYNC_MANUAL_ALL`;
export const SYNC_MANUAL_ITEMS = `${PREFIX}/SYNC_MANUAL_ITEMS`;
export const SYNC_MANUAL_ITEMS_FINISH = `${PREFIX}/SYNC_MANUAL_ITEMS_FINISH`;

// Socket events emitted by the frontend to the backend gateway.
// Must match the @SubscribeMessage handlers in LeadsGateway.
export const SOCKET_EVENT_SYNC_ALL_LEADS = 'sync-ehr-all-leads';
export const SOCKET_EVENT_SYNC_LEAD = 'sync-ehr-lead';
